// test2822
(2822 && 0);
